:host {

}

.stzh-eventinfo {
  display: flex;

  &__left {
    @include fontSize('nano');
    flex-shrink: 0;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $colorBlack;
    background-color: $colorSecondary30;
    padding-top: space('small');
    width: 72px;

    @include mq($from: small) {
      width: 88px;
    }
  }

  &__main-event-day {
    @include font('heavy');
    @include fontSize('hecto');
    color: $colorPrimary70;
    margin-top: -7px;
    margin-bottom: -7px;
  }

  &__right {
    @include fontSize('centi');
    flex-grow: 1;
    color: $colorGrey80;
    background-color: $colorGrey10;
    padding-top: space('small');
    padding-bottom: space('medium');
    padding-left: space('small');
    padding-right: space('medium');

    @include mq($from: small) {
      padding-left: space('xlarge');
      padding-right: space('xlarge');
    }

    @include mq($from: medium) {
      padding-top: space('medium');
      padding-bottom: space('large');
    }

    @include mq($from: large) {
      padding-top: space('large');
      padding-bottom: space('xlarge');
    }
  }

  &__head {
    display: flex;
    flex-direction: column;
    column-gap: space('large');

    @include mq($from: medium) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__main-date {
    display: flex;
    column-gap: space('medium');
    flex-wrap: wrap;
  }

  &__main-event-link {
    flex-shrink: 0;
  }

  &__text {
    display: flex;
    flex-direction: column;
    row-gap: space('medium');
    column-gap: space('large');
    margin-top: space('medium');

    @include mq($from: medium) {
      @include spaceCurve('margin-top', 'tiny');
    }
  }

  &__details-wrapper {
    margin-top: space('medium');

    @include mq($from: medium) {
      @include spaceCurve('margin-top', 'tiny');
    }
  }

  &__details {
    color: inherit;
  }

  &__details-link-collapse {
    display: none;
  }

  &__details-link[a11y-expanded]:not([a11y-expanded="false"]) &__details-link-collapse {
    display: block;
  }

  &__details-link[a11y-expanded]:not([a11y-expanded="false"]) &__details-link-expand {
    display: none;
  }

  &__month-list,
  &__event-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__month-list {
    @include fontCurve('p1');
    display: grid;
    column-gap: space('small');

    @include mq($from: small) {
      grid-template-columns: minmax(0, 1fr) auto;
    }

    @include mq($from: medium) {
      column-gap: space('xxlarge');
      grid-template-columns: minmax(100px, auto) minmax(180px, auto) minmax(0, 1fr) auto;
    }
  }

  &__month-list-item:not(:first-child) &__heading {
    @include spaceCurve('margin-top', 'regular');
  }

  &__month-list-item {
    display: contents;
  }

  &__month-list-item:last-child &__event-list-item:last-child &__event-weekday,
  &__month-list-item:last-child &__event-list-item:last-child &__event-date,
  &__month-list-item:last-child &__event-list-item:last-child &__event-time,
  &__month-list-item:last-child &__event-list-item:last-child &__event-link,
  &__month-list-item:last-child &__event-list-item:last-child &__event-datetime-wrapper {
    margin-bottom: 0px;
  }

  &__heading {
    @include font('title');
    @include fontSize('centi', 'heading');
    @include spaceCurve('margin-bottom', 'tiny');
    margin-top: 0;
    color: $colorPrimary70;

    @include mq($from: small) {
      grid-column: 1 / 3;
    }

    @include mq($from: medium) {
      grid-column: 1 / 5;
    }
  }

  &__event-list {
    display: contents;
  }

  &__event-list-item {
    display: contents;
  }

  &__event-weekday,
  &__event-date,
  &__event-time {
    @include mq($from: medium) {
      margin-bottom: space('small');
    }

    @include mq($from: large) {
      margin-bottom: space('medium');
    }
  }

  &__event-link {
    margin-bottom: space('medium');

    @include mq($from: medium) {
      margin-bottom: space('small');
    }

    @include mq($from: large) {
      margin-bottom: space('medium');
    }
  }

  &__event-datetime-wrapper {
    display: grid;

    @include mq($from: small, $to: medium) {
      margin-bottom: space('medium');
    }

    @include mq($from: medium) {
      display: contents;
    }
  }

  &__event-date-wrapper {
    display: flex;
    flex-direction: column;
    column-gap: space('xxlarge');

    @include mq($from: medium) {
      display: contents;
    }
  }

  &__event-weekday {
    @include mq($from: small, $to: medium) {
      min-width: 90px;
    }
  }
}
